import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PasswordInfo} from './domain/password.info';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {
  changePassword(apiAddress: string, passwordInfo: PasswordInfo, HttpOptions): Observable<any> {
    return this.http.post<any>(apiAddress , passwordInfo, HttpOptions);

  }

  constructor(private http: HttpClient) {
  }
}
